export default __webpack_public_path__ + "static/media/startlater@3x.ecdf05aa.jpg";